<script>
import NavBar from '@components/nav-bar.vue'
import CustomFooter from '@components/custom-footer.vue'

export default {
  components: { CustomFooter, NavBar },
}
</script>

<template>
  <div :class="$style['main-cont']">
    <NavBar />
    <div :class="$style.container">
      <slot />
    </div>
    <div :class="$style['footer-bottom']">
      <CustomFooter />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
/* stylelint-disable */
.main-cont {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.container {
  min-width: $size-content-width-max;
  max-width: $size-content-width-max;
  margin: 0 auto;
  flex: 1 0 auto;
}

.footer-bottom {
  flex-shrink: 0;
}

@media screen and (max-width: 1000px) {
  .container {
    min-width: $size-content-width-min;
  }
}
</style>
